<script>
import { get } from 'lodash';
import { mapActions } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faChevronDown } from '@fortawesome/free-solid-svg-icons';

library.add(faCheckCircle, faChevronDown);

export default {
  name: 'Course_B_Box',
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cover() {
      return get(this, 'course.url', null);
    },
  },
  methods: {
    ...mapActions('user', [
      'fetchCourse',
    ]),
    setCourse(id) {
      this.fetchCourse(id)
        .then(res => {
          if (!res) {
            return;
          }

          if (this.$route.name !== 'home') {
            return this.$router.push({ name: 'home' });
          }
        })
      ;
    },
  },
}
</script>
<style lang="scss">
    @import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";
    .course-box {
        box-shadow: 1.5px 2.6px 10px 0 rgba(119, 119, 119, .75);
        height: 14.3em;
        &--content {
            flex: 1;
        }
        &--action {
            display: flex;
            justify-content: space-between;
            a {
                cursor: pointer;
                color: #beb6a1;

                &.dark {
                    color: #1e1e1e;
                    font-weight: bold;
                    font-size: .85em;
                    &:hover {
                        color: #beb6a1;
                    }
                }
            }
        }
        &--inner-content {
            overflow: hidden;
            width: 100%;

            p {
                margin: 0;
            }

            & > ul {
                /*display: flex;*/
                li {
                    /*width: 50%;*/
                    display: flex;
                    &:before {
                        font-family: FontAwesome;
                        content: '\f058';
                        color: #85d5d6;
                        margin-right: .5em;
                    }
                    &:first-child {
                        background-color: transparent;
                    }
                }
            }
        }

        figure {
            margin: 0;
            img {
                max-width: 25em;
                max-height: 14.3em;
                height: auto;
                border-radius: .25rem 0 0 .25rem;
            }
        }

        @media screen and (max-width: 768px) {
            flex-direction: column;
            max-height: 30em;
            height: auto;
            padding-bottom: 1em;
            overflow: hidden;

            &--inner-content {
                max-height: 14.3em;
                overflow: hidden;
            }

            figure {
                height: 14.3em;
                overflow: hidden;

                img {
                    max-width: fit-content;
                    max-height: none;
                    width: 100%;
                }
            }
        }
    }
</style>
<template>
    <div class="course-box bg-white rounded mb-5 d-flex">
        <figure v-if="cover">
            <img :src="cover" :alt="course.title" />
        </figure>
        <div class="course-box--content d-flex p-3 pl-5 pr-5 flex-column">
            <div class="course-box--action">
                <a @click="setCourse(course.id)">
                    <h5>{{ course.title }} »</h5>
                </a>
                <a @click="setCourse(course.id)" class="dark">
                    ROZWIŃ
                    <font-awesome-icon icon="chevron-down" />
                </a>
            </div>
            <div v-html="course.content" class="course-box--inner-content" />
        </div>
    </div>
</template>
